import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      position: 'Operations Director',
      company: 'TechManufacturing India',
      image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh',
      rating: 5,
      text: 'Sight Vision transformed our warehouse operations completely. We saw a 40% increase in efficiency within the first 3 months. Their WMS solution is best-in-class.'
    },
    {
      name: 'Priya Sharma',
      position: 'Supply Chain Manager',
      company: 'RetailGiant Corp',
      image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Priya',
      rating: 5,
      text: 'The RFID tracking system has been a game-changer for our inventory management. Real-time visibility across all our stores has reduced stockouts by 60%.'
    },
    {
      name: 'Amit Patel',
      position: 'CEO',
      company: 'LogisticsHub Solutions',
      image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Amit',
      rating: 5,
      text: 'Outstanding service and support! The mobile app for our field teams has improved productivity significantly. Highly recommend Sight Vision for any supply chain needs.'
    },
    {
      name: 'Sarah Johnson',
      position: 'Warehouse Manager',
      company: 'Global Distributors Ltd',
      image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
      rating: 5,
      text: 'The IoT integration and predictive maintenance features have saved us thousands in equipment downtime. The ROI was evident within 6 months.'
    }
  ];

  return (
    <section className="py-20 px-4 bg-slate-50">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">What Our Clients Say</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">Don't just take our word for it - hear from satisfied customers</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <CardContent className="pt-6">
                <div className="flex items-start space-x-4 mb-4">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full border-4 border-blue-100"
                  />
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-slate-900">{testimonial.name}</h3>
                    <p className="text-sm text-slate-600">{testimonial.position}</p>
                    <p className="text-sm font-medium text-blue-600">{testimonial.company}</p>
                  </div>
                  <Quote className="w-8 h-8 text-blue-200" />
                </div>
                
                <div className="flex space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                
                <p className="text-slate-700 leading-relaxed italic">"{testimonial.text}"</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;